import { render, staticRenderFns } from "./Triangle.vue?vue&type=template&id=d03c09b8&"
import script from "./Triangle.vue?vue&type=script&lang=js&"
export * from "./Triangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports